import { Rejected } from 'services/http';

const requestRejected = (value: Rejected): Rejected => value;

export default requestRejected;
